import { useState } from 'react';
import { FilterAccordionContainer, FilterContainer, FilterHeader } from '~/components/Filter';
import { DeviceFilterAccordions } from '~/components/devices';
import type { DeviceList__FilterCount } from '../../queries/list.generated';
import { useDeviceFilters } from '../context';
import { FilterFooter } from './FilterFooter';
import { NewFilterDialog } from './NewFilterDialog';
import { SavedFilterSelector } from './SavedFilterSelector';

export interface FilterAccordionProps {
  filterCounts: DeviceList__FilterCount | undefined;
}

export const FilterAccordion = ({ filterCounts }: FilterAccordionProps) => {
  const [newFilterDialogOpen, setNewFilterDialogOpen] = useState(false);
  const { clearFilters } = useDeviceFilters();

  return (
    <>
      <FilterContainer>
        <FilterHeader />
        <SavedFilterSelector />
        <FilterAccordionContainer>
          <DeviceFilterAccordions filterCounts={filterCounts} />
        </FilterAccordionContainer>
        <FilterFooter handleClear={clearFilters} handleSave={() => setNewFilterDialogOpen(true)} />
      </FilterContainer>
      <NewFilterDialog
        onClose={() => {
          setNewFilterDialogOpen(false);
        }}
        open={newFilterDialogOpen}
      />
    </>
  );
};
